const semanticClassNames = {
  root: 'text-effects',
} as const;

export default semanticClassNames;
